import React from 'react';
import { ColorPicker } from '~/Components/ColorPicker';
import { ItemCreationFieldValue } from '~/Components';

interface ItemCreationColorPickerProps {
  setFieldValue: ItemCreationFieldValue;
  fieldName: string;
  color: string;
  disabled?: boolean;
}

export const ItemCreationColorPicker = ({
  setFieldValue,
  fieldName,
  color,
  disabled,
}: ItemCreationColorPickerProps) => {
  const updateColor = (newColor: string) => {
    setFieldValue(fieldName, newColor);
  };

  return <ColorPicker updateColor={updateColor} color={color} disabled={disabled} />;
};
